<template>
    <textarea :class="{'disabled': disabled}"
              :style="style" 
              v-model="text"                   
              rows="10"
              cols="30">
    </textarea>
</template>

<script>
import rgbaToCss from '@mixins/rgba-to-css'

export default {
    data() {
        return {
            text: ''
        }
    },

    props: {
        dataHeading: {
            type: String,
        },
        dataColor: {
            type: Object,
        },
        openFieldStyle: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            default: true
        }
    },

    watch: {
        text(val) {
            if(val && val.length > 250) {
                this.text = val.slice(0, 250)
            }
        }
    },

    computed: {
        isBackgroundColorOpenFieldActive() {
            return this.openFieldStyle.background.active
        },
        backgroundColorOpenField() {
            return this.openFieldStyle.background.color
        },
        textColorOpenField() {
            return this.openFieldStyle.textColor
        },
        style() {
            return typeof this.backgroundColorOpenField === "object" ?             
            {
                "background-color": this.isBackgroundColorOpenFieldActive ?
                                    this.rgbaToCss(this.backgroundColorOpenField) :
                                    null,
                "color": this.rgbaToCss(this.textColorOpenField)
            }  :
            {
                "background": this.backgroundColorOpenField,
                "color": this.rgbaToCss(this.textColorOpenField)
            }        
        },
    },

    methods: {},

    mixins: [rgbaToCss]
}
</script>

<style scoped>
    .question{
        word-wrap: break-word;
    }    

    textarea {
        resize: none;
        border-radius: 24px;
        padding: 19px 13px;
        width: 100%;
        max-width: 400px;
        position: relative;       

       &.disabled {
        pointer-events: none;
       }

       &:focus {
        outline: none;
       }
    }
    
</style>
